import $ from 'jquery'

const toTopBtn = $('#return-to-top');
const $window = $(window);
const root = $('html,body');

window.addEventListener('scroll', function () {
  if ($window.scrollTop() >= 50) {
    toTopBtn.addClass('is-visible');
  }
  else {
    toTopBtn.removeClass('is-visible');
  }
}, {passive: true});

toTopBtn.click(function () {
  root.animate({scrollTop: 0}, 500)
});
